import { LOCAL_QnA_INFO } from "../../constants/localData";
import {
  Answer,
  Container,
  GridContainer,
  QnaBlockTitle,
  QnaSection,
  Question,
} from "./QnABlock.styles";

type QnABlockData = {
  ques: string;
  info: string;
};

type QnABlockProps = {
  data?: QnABlockData[];
  qnaBlockTitle?: string;
};

const QnABlock = ({ data, qnaBlockTitle }: QnABlockProps) => {
  const qnaData = data || [];

  return (
    <Container>
      <QnaBlockTitle>{qnaBlockTitle}</QnaBlockTitle>
      <GridContainer>
        {qnaData.map((qna, index) => (
          <QnaSection key={index} index={index}>
            <Question>{qna.ques}</Question>
            <Answer dangerouslySetInnerHTML={{ __html: qna.info }} />
          </QnaSection>
        ))}
      </GridContainer>
    </Container>
  );
};

export default QnABlock;
